import {useEffect, useState} from "react";

type IdTokenCallback = () => Promise<string>

export interface ExternalUser {
  name: string
  picture?: string
  idTokenCallback?: IdTokenCallback
}

type ExternalUserListener = (user: ExternalUser|undefined) => void

export interface ExternalUserProvider {
  getCurrentUser: () => ExternalUser|undefined
  setCurrentUser: (c: ExternalUser|undefined) => void
  addCurrentUserListener: (listener: ExternalUserListener) => void
  removeCurrentUserListener: (listener: ExternalUserListener) => void
  triggerLogin?: () => void
  triggerLogout?: () => void
}

export function useExternalUser(externalUserProvider: ExternalUserProvider|undefined): ExternalUser|undefined {
  const [externalUser, setExternalUser] = useState<ExternalUser|undefined>(externalUserProvider ? externalUserProvider.getCurrentUser() : undefined);

  useEffect(() => {
    if(externalUserProvider) {
      externalUserProvider.addCurrentUserListener(setExternalUser)
      return () => {
        externalUserProvider.removeCurrentUserListener(setExternalUser);
      }
    }
  }, [externalUserProvider,setExternalUser])

  return externalUser;
}


